export default __webpack_public_path__ + "static/media/tshirt.a851aed5.jpg";